<template>
  <div class="download-input">
    <div class="form-group row">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <form action="/api/admin/form/download" method="post" ref="form">
          <input type="hidden" name="token" v-model="token">
          <input type="hidden" name="permalink" v-model="options.permalink">
          <input type="hidden" name="data" v-model="value">
        </form>
        <button class="btn btn-sm btn-primary" type="button" @click="download()">
          <span class="fa fa-download fa-fw"></span> <span v-if='!options.justShowResult'>Download</span>
          <span v-else>Get Result</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import { OPEN_ERROR_MODAL, OPEN_MODAL } from '@/vuex/types'
import Api from '@/vuex/api'
import Modal from '../Modal'

export default {
  name: 'DownloadInput',
  components: {
    Modal
  },
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          justShowResult: false,
          name: '',
          label: '',
          permalink: ''
        }
      }
    }
  },
  data () {
    return {
      message: '',
      isValid: true,
      isDirty: true,
      token: ''
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  methods: {
    async download () {
      this.token = window.sessionStorage.getItem('token')
      await this.$nextTick()
      let data = {}
      switch (this.options.permalink) {
        case 'downloadMonthlyInvoice':
          data = JSON.parse(this.value)
          try {
            if (!data.month || !data.year) {
              throw new Error('You did not select a month and year to generate an invoice for')
            } else {
              if (moment(`${data.month} ${data.year}`, 'MMMM YYYY').isSame(moment(), 'month')) {
                throw new Error('Cannot generate an invoice for the current month, since it has not been finalised')
              }
            }
            this.$refs.form.submit()
          } catch (e) {
            this.$store.dispatch(OPEN_ERROR_MODAL, e)
          }
          break
        case 'downloadContractReport':
          data = JSON.parse(this.value)
          try {
            if (!data.month || !data.year) {
              throw new Error('You did not select a month and year to generate a report for')
            } else {
              if (moment(`${data.month} ${data.year}`, 'MMMM YYYY').isSame(moment(), 'month')) {
                throw new Error('Cannot generate an invoice for the current month, since it has not been finalised')
              }
            }
            this.$refs.form.submit()
          } catch (e) {
            this.$store.dispatch(OPEN_ERROR_MODAL, e)
          }
          break
        case 'getRebatePromoIncome':
          data = JSON.parse(this.value)
          try {
            if (!data.month || !data.year) {
              throw new Error('You did not select a month or year to generate a report for')
            } else {
              if (moment(`${data.month} ${data.year}`, 'MMMM YYYY').isSame(moment(), 'month')) {
                throw new Error('Cannot generate a report for the current month, since it has not been finalised')
              }
            }
            let instance = new Api()
            let responseData = await instance.getRebatePromoIncome({
              checkVal: { ...JSON.parse(this.value) }
            })
            // Generating a modal to show the results.
            let html = `<p>Total Income: <b>$${responseData.totalIncome}</b>.</p><p><b>${responseData.percentRebate}%</b> of Income: <b>$${responseData.finalRebate}.</b></p>`
            let previewModal = {
              title: 'Results',
              html
            }
            this.$store.dispatch(OPEN_MODAL, previewModal)
          } catch (e) {
            this.$store.dispatch(OPEN_ERROR_MODAL, e)
          }
          break
      }
    },
    runWatcher (val, name) {
      let value = JSON.parse(this.value)
      switch (name) {
        case 'month':
          value.month = val
          this.$emit('input', JSON.stringify(value))
          break
        case 'year':
          value.year = val
          this.$emit('input', JSON.stringify(value))
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DownloadInput.vue